import ExacqVisionVMS from 'features/exacqvision-vms/ExacqVisionVMS.index';

export default function ExacqVisionVMSRoute() {
  return <ExacqVisionVMS />;
}
